<template>
  <div class="text-center mb-12">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-16 h-16 text-psychology-primary mx-auto mb-6">
      <path d="M12 7v14"></path>
      <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path>
    </svg>
    <h1 class="text-4xl font-bold text-gray-900 mb-4">使用指南</h1>
    <p class="text-xl text-gray-600 max-w-2xl mx-auto">
      详细了解如何正确使用恋爱占有欲指数(RPI)评估工具，获得准确可靠的测评结果
    </p>
  </div>
</template>

<script>
export default {
  name: 'GuideHeader'
}
</script>

